<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('requested trips')"
      :columns="columns"
      :column_search="true"
      resource_url="/trip/request/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="calendar">
          <span class="icon"><i class="fa fa-calendar"></i></span>
          <span>{{ $t("calendar") }}</span>
        </button>
      </template>
    </generic-table>
    <trip-assign-modal ref="trip_assign_modal" @success="refresh" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  error_message,
  format_currency,
  format_date,
  format_date_time,
} from "@/utils";
import TripAssignModal from "./trip_assign_modal/Index.vue";

export default {
  name: "DriverDatatable",
  components: { GenericTable, TripAssignModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("request date"),
          searchable: false,
          // width: "12%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date_time(row.create_date);
          },
        },
        {
          title: v.$t("trip date"),
          searchable: false,
          // width: "12%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date(row.date);
          },
        },
        // {
        //   title: v.$t("status"),
        //   // width: "12%",
        //   data: (row) => {
        //     // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     return v.translate_status(row.status_code);
        //   },
        // },
        {
          title: v.$t("trip"),
          searchable: true,
          // width: "12%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `<span class="icon"><i class="fa fa-map-marker"></i></span>${row.origin} <span class="icon"><i class="fa fa-arrow-right"></i></span> ${row.destination}`;
          },
        },
        {
          title: v.$t("requestor"),
          searchable: false,
          // width: "12%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `<div class="title is-6">${row.name}</div>
                    <div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-phone"></i></span>${row.phone}</div>
                    <div class="subtitle is-6"><span class="icon"><i class="fa fa-envelope"></i></span>${row.email}</div>`;
          },
        },
        {
          title: v.$t("space"),
          searchable: true,
          // width: "25%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `<div class="field is-grouped is-grouped-multiline">
                      <div class="control">
                        <div class="tags has-addons">
                          <span class="tag is-dark">${v.$t(
                            "number of passengers"
                          )}</span>
                          <span class="tag is-info">${
                            row.passenger_number
                          }</span>
                        </div>
                      </div>
                      <div class="control">
                        <div class="tags has-addons">
                          <span class="tag is-dark">${v.$t(
                            "luggage number"
                          )}</span>
                          <span class="tag is-info">${row.luggage_number}</span>
                        </div>
                      </div>
                    </div>`;
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("reject"),
                icon: "fa fa-ban has-text-danger",
                icon_class: "is-small",
                click: function (e) {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to reject trip?"),
                    v,
                    () => {
                      post("/trip/request/reject", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("add to scheduled trip"),
                icon: "fa fa-car",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.trip_assign_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete trip?"),
                    v,
                    () => {
                      del("/trip/request", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    format_date_time,
    format_currency,
    calendar() {
      let v = this;
      v.$router.push({
        path: "/trip/requested-calendar",
      });
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    edit_driver(item) {
      let v = this;
      v.$refs.driver_modal.edit_modal(item.uuid);
    },
    delete_driver(item) {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete driver?"), v, () => {
        del("/trip/driver", { uuid: item.uuid })
          .then(() => {
            v.refresh();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },
    translate_status(status_code) {
      let v = this;
      let status = status_code;
      switch (status_code) {
        case "N":
          status = v.$t("new");
          break;
        case "R":
          status = v.$t("rejected");
          break;
        case "A":
          status = v.$t("assigned");
          break;
        default:
          break;
      }
      return status;
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
